import Launchpad from 'launchpad-webmidi';
import Resolution from 'engine/Resolution.js';

class LaunchPad2 {
    constructor(sequencerEngine, input, output) {
        this.sequencerEngine = sequencerEngine;
        this.store = this.sequencerEngine.store;
        this.input = input;
        this.output = output;
        this.step = 0;
        this.subSequenceNumber  = 0;
        this.patternNumber = 0;
        this.numberOfPatterns = 1;

        this.setupLights();
        this.setupListeners();
    }

    setupListeners() {
        this.input.addListener(
            'noteon', "all", (e) => {
            });
        this.input.addListener(
            'noteoff', "all", (e) => {
            });

        this.store.subscribe(() => this.onStateUpdate());
    }

    onStateUpdate() {
        let state = this.store.getState();

        // get the current subSequenceId
        let subSequence = this.sequencerEngine.getSubSequence(
            state.sequencer.currentSubSequence);
        if (subSequence === undefined) {
            return;
        }
        let subSequenceNumber = this.sequencerEngine.subSequences.indexOf(subSequence);
        let patternNumber = state.sequencer.currentPattern[subSequence.id]
        let numberOfPatterns = state.sequencer.numberOfPatterns;

        if (this.subSequenceNumber !== subSequenceNumber ||
            this.patternNumber !== patternNumber ||
            this.numberOfPatterns !== numberOfPatterns) {
            this.patternNumber = patternNumber;
            this.subSequenceNumber = subSequenceNumber;
            this.idToPattern = state.sequencer.currentPattern;
            this.numberOfPatterns = numberOfPatterns;

            this.onStateChanged();
        }


    }

    onStateChanged() {
        this.pad.reset(8);             // Make Launchpad glow yellow
        console.log(
            'patternNumber = ' +
                this.patternNumber +
                ' and subSequenceNumber = ' + this.subSequenceNumber);

        this.color(this.pad.red, 8, this.subSequenceNumber);

        for (let i=0; i < this.sequencerEngine.subSequences.length; i++) {
            this.color(this.pad.red, 0, i);
        }

        for (let id in this.idToPattern) {
            id = parseInt(id);
            console.log('id we got = ' + id);
            let subSequence = this.sequencerEngine.getSubSequence(id);
            if (subSequence === undefined) {
                return;
            }
            let y = this.sequencerEngine.subSequences.indexOf(
                subSequence);
            let x = this.idToPattern[id];
            let track = subSequence.tracks[0];
            if (track !== undefined) {
                // set the unselected patterns to yellow
                for (let i=0; i < Math.min(8, track.patterns.length); i++) {
                    this.color(this.pad.yellow, i, y);
                }
            }

            console.log('coloring x = ' + x + ' y =' + y);
            this.color(this.pad.red, x, y);
        }
    }

    onTick() {
    }

    setupLights() {
        this.pad = new Launchpad();
        this.pad.connect().then(() => {     // Auto-detect Launchpad
            this.pad.reset(8);             // Make Launchpad glow yellow
            this.pad.on('key', k => this.handleKeyPressed(k)); 
            this.onStateUpdate();
        });
    }

    handleKeyPressed(k) {
        let x = k.x;
        let y = k.y;
        let pressed = k.pressed;
        if (!pressed) {
            return;
        }

        let subSequence = this.sequencerEngine.subSequences[y];
        if (subSequence === undefined) {
            return;
        }

        let track = subSequence.tracks[0];
        if (track === undefined) {
            return;
        }

        if (x < track.patterns.length) {
            this.sequencerEngine.switchToSubSequence(subSequence.id);
            this.sequencerEngine.switchToPattern(x);
        }
    }

    color(color, x, y) {
        this.pad.col(
            color, {
                0: x,
                1: y,
                x: x,
                y: y,
                length: 2,
                pressed: true});
    }
}

export default LaunchPad2;
